
<template>

    <div class="outer-wrapper">

        <div class="image-wrapper">

            <font-awesome-icon icon="check-circle" class="check-circle" />
        </div>
        <div class="details-wrapper">

            <h2>Thank You!</h2>
            <p>

                Your payment was accepted and your order is being prepared, see you soon!
            </p>
            <p class="subtext">

                Contact us directly for any last minute changes to your order
            </p>
            <p class="order-number">

                Order# {{ thisOrderNumber }}
            </p>
            <div class="logo-wrapper">

                <img src=" ../../../img/logo.jpg" />
            </div>
            <p><b>(954) 314 - 7686</b></p>
        </div>

    </div>

</template>

<script>

    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
    import { mapGetters } from 'vuex';

    export default {

        name: 'order-success',
        computed: {

            ...mapGetters({

                thisOrderNumber : 'orderTab/thisOrderNumber'
            })
        },
        components: {

            FontAwesomeIcon
        }
    }
</script>

<style scoped>

    .outer-wrapper {

        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 0px !important;
    }
    .image-wrapper {

        text-align: center;
        padding: 15px 0px;
    }

    .check-circle {

        color: #65A52B;
        font-size: 125px;
    }

    .logo-wrapper {

        width: 125px;
        margin: auto;
    }
    .logo-wrapper > img {

        width: 100%;
        height: 100%;
    }
    .details-wrapper {

        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .details-wrapper > h2 {

        margin: 0px auto;
    }
    .details-wrapper > p {

        margin: 0 auto 15px;
        text-align: center;
        max-width: 250px;
    }
    .subtext {

        font-size: 0.8rem;
    }

    .order-number {

        font-size: 20px;
        font-weight: bold;
        margin: 0;
    }
</style>